<template>
  <div class="prizes-page">
    <div class="prizes-shell">
      <header class="prizes-header">
        <button class="prizes-back" type="button" :aria-label="$t('prizesBack')" @click="back">
          <img src="../../static/images/prizes/back.png" alt="" />
        </button>
        <img v-if="$i18n.locale === 'en'" class="prizes-heading-image" src="../../static/images/prizes/prizes.png" :alt="$t('prizesTitle')" />
        <h1 v-else class="prizes-heading-text">{{ $t('prizesTitle') }}</h1>
      </header>

      <p class="prizes-description">
        <span class="prizes-description-copy">{{ $t('prizesIntroBefore') }}<span class="prizes-highlight-box">{{ $t('prizesLuckyBoxes') }}</span>{{ $t('prizesIntroMiddle') }}<strong>{{ $t('prizesRewards') }}</strong></span>
      </p>

      <main class="prizes-content">
        <div v-for="(row, rowIndex) in prizeRows" :key="rowIndex" class="prizes-row" :class="row.layout">
          <div v-for="prize in row.items" :key="prize.labelKey" class="prize-card">
            <img :src="prize.image" :alt="$t(prize.labelKey)" />
            <span class="prize-card-label"><span>{{ $t(prize.labelKey) }}</span></span>
          </div>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
const prizeRows = [
  {
    layout: 'prizes-row-featured',
    items: [
      {image: require('../../static/images/prizes/cash_300000.png'), labelKey: 'prizesCash300000'}
    ]
  },
  {
    layout: 'prizes-row-major',
    items: [
      {image: require('../../static/images/prizes/gold_ring.png'), labelKey: 'prizesGoldRing'},
      {image: require('../../static/images/prizes/smart_phone.png'), labelKey: 'prizesSmartPhone'}
    ]
  },
  {
    layout: 'prizes-row-small',
    items: [
      {image: require('../../static/images/prizes/cash_100000.png'), labelKey: 'prizesCash100000'},
      {image: require('../../static/images/prizes/top_up.png'), labelKey: 'prizesTopUp20000'},
      {image: require('../../static/images/prizes/top_up.png'), labelKey: 'prizesTopUp10000'}
    ]
  },
  {
    layout: 'prizes-row-small',
    items: [
      {image: require('../../static/images/prizes/data.png'), labelKey: 'prizesData3GB'},
      {image: require('../../static/images/prizes/data.png'), labelKey: 'prizesData1GB'},
      {image: require('../../static/images/prizes/data.png'), labelKey: 'prizesData500MB'}
    ]
  },
  {
    layout: 'prizes-row-last',
    items: [
      {image: require('../../static/images/prizes/data.png'), labelKey: 'prizesData100MB'},
      {image: require('../../static/images/prizes/data.png'), labelKey: 'prizesData50MB'}
    ]
  }
]

export default {
  data() {
    return {prizeRows}
  },
  methods: {
    back() {
      if (window.history.length > 1) {
        this.$router.go(-1)
      } else {
        this.$router.push({path: '/'})
      }
    }
  }
}
</script>

<style scoped>
.prizes-page {
  width: 100%;
  min-height: 100vh;
  background: #080f39 url(../../static/images/prizes/prize_bg.jpg) no-repeat center top;
  background-size: 100% 100%;
  color: #fff;
  font-family: Atom-sans;
}

.prizes-shell {
  width: 100%;
  max-width: 7.5rem;
  min-height: 100vh;
  margin: 0 auto;
  padding: 0.68rem 0.26rem 0.22rem;
}

.prizes-header {
  position: relative;
  height: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.prizes-back {
  position: absolute;
  top: 50%;
  left: 0.05rem;
  width: 0.72rem;
  height: 0.72rem;
  padding: 0;
  border: 0;
  background: none;
  transform: translateY(-50%);
  cursor: pointer;
}

.prizes-back img {
  display: block;
  width: 100%;
  height: 100%;
}

.prizes-heading-image {
  display: block;
  width: 3.15rem;
  height: auto;
}

.prizes-heading-text {
  max-width: 5.25rem;
  margin: 0;
  color: #fff;
  font-family: Atom-sans-bold;
  font-size: 0.55rem;
  line-height: 1.1;
  text-align: center;
  text-shadow: 0 0 0.24rem #824dff;
}

.prizes-description {
  width: 5.55rem;
  min-height: 0.9rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0.16rem auto 0.25rem;
  padding: 0.1rem 0.25rem;
  background: url(../../static/images/prizes/txt_bg.png) no-repeat center;
  background-size: 100% 100%;
  font-size: 0.26rem;
  line-height: 1.2;
  text-align: center;
}

.prizes-description-copy {
  display: block;
}

.prizes-highlight-box {
  color: #42e8ff;
}

.prizes-description strong {
  color: #a6ff38;
  font-weight: normal;
}

.prizes-content {
  width: 100%;
}

.prizes-row {
  width: 100%;
}

.prizes-row-featured {
  display: flex;
  justify-content: center;
}

.prizes-row-featured .prize-card {
  width: 3.98rem;
}

.prizes-row-major {
  display: flex;
  justify-content: space-between;
  margin-top: -0.25rem;
}

.prizes-row-major .prize-card {
  width: 3.27rem;
}

.prizes-row-small {
  display: flex;
  justify-content: space-between;
  margin-top: -0.18rem;
}

.prizes-row-small .prize-card {
  width: 2.24rem;
}

.prizes-row-last {
  display: flex;
  justify-content: center;
  gap: 0.18rem;
  margin-top: -0.15rem;
}

.prizes-row-last .prize-card {
  width: 2.3rem;
}

.prize-card {
  position: relative;
  min-width: 0;
}

.prize-card img {
  display: block;
  width: 100%;
  height: auto;
}

.prize-card-label {
  position: absolute;
  top: 72%;
  left: 50%;
  width: 78%;
  height: 26%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-family: Atom-sans-bold;
  font-size: 0.26rem;
  line-height: 1.08;
  text-align: center;
  overflow-wrap: anywhere;
  transform: translateX(-50%);
}

.prize-card-label > span {
  transform: translateY(0.02rem);
}

.prizes-row-featured .prize-card-label {
  top: 65%;
  width: 72%;
  height: 29%;
  font-size: 0.27rem;
}

.prizes-row-small .prize-card-label,
.prizes-row-last .prize-card-label {
  top: 70%;
  width: 86%;
  height: 30%;
  font-size: 0.21rem;
}

@media (min-width: 481px) {
  .prizes-page {
    box-shadow: 0 0 0 100vmax #0d123b;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/luckyDraw.vue